module.exports = __webpack_public_path__ + "img/icon01.73c8f07a.png";